// 문제뱅크 문해력(국어 독해) 도우미. 전자책(reading_book/ReadingBookPage)이 쓴다.
// 수준(초 · 중 · 고)에 따라 색을 바꾼다(지인에듀 '문해력 국어 디자인 문제집판'). 수준은 유형 꼬리표("KR5 ...")에서 읽는다.

const READING_THEME_LIST = [
  { maximumLevel: 3, color: "#F08A1C", sub: "#E2402F", soft: "#FFF4E6" },
  { maximumLevel: 6, color: "#1F86C2", sub: "#F08A1C", soft: "#E8F4FB" },
  { maximumLevel: 9, color: "#7A3D9C", sub: "#1F86C2", soft: "#F3ECF8" },
];
const CIRCLED_NUMBER = "①②③④⑤⑥⑦⑧⑨⑩";

export const levelOfCategory = (category) => {
  const match = /KR\s*(\d)/i.exec(String(category || ""));
  return match ? Number(match[1]) : null;
};

export const readingThemeOf = (category) => {
  const level = levelOfCategory(category) || 1;
  return READING_THEME_LIST.find((theme) => level <= theme.maximumLevel) || READING_THEME_LIST[0];
};

// 꼬리표에서 수준 표시("KR5")를 떼고 유형 이름만
export const readingTypeName = (category) => String(category || "").replace(/KR\s*\d\s*/i, "").trim();

// 해설 "정답 ②: … ①: … ③: …" 를 정답 이유와 선지별 오답 이유로 나눈다. 모양이 다르면 통째로 둔다.
export const splitReadingExplanation = (explanation) => {
  const text = String(explanation || "");
  const markList = [...text.matchAll(/(정답\s*)?([①②③④⑤⑥⑦⑧⑨⑩])\s*[:：]/g)];
  if (markList.length < 2) return { main: text, reasonByIndex: {} };
  const reasonByIndex = {};
  let main = text.slice(0, markList[0].index).trim();
  markList.forEach((mark, order) => {
    const end = order + 1 < markList.length ? markList[order + 1].index : text.length;
    const body = text.slice(mark.index + mark[0].length, end).trim();
    if (mark[1]) {
      main = [main, body].filter(Boolean).join(" ");
    } else {
      reasonByIndex[CIRCLED_NUMBER.indexOf(mark[2])] = body;
    }
  });
  return { main, reasonByIndex };
};
